import fetch from 'auth/FetchInterceptor'
import { AUTH_TOKEN } from 'constants/AuthConstant';

const AuthService = {}

AuthService.login = async function (data) {
	try {
		const response = await fetch({
			url: 'https://itframe.unmutedte.ch/authenticate',
			method: 'post',
			data: data
		});
		return response;
	} catch (error) {
		console.error("AuthService login error:", error);
		throw error;
	}
};

AuthService.adminLogin = async function (data) {
	try {
		const response = await fetch({
			url: 'https://itframe.unmutedte.ch/admin/authenticate',
			method: 'post',
			data: data
		});
		return response;
	} catch (error) {
		console.error("AuthService admin login error:", error);
		throw error;
	}
};


AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data
	})
}

AuthService.logout = async function () {
    try {
        localStorage.removeItem(AUTH_TOKEN);
    } catch (error) {
        console.error("AuthService logout error:", error);
        throw error; 
    }
};

export default AuthService;
